import angular from 'angular';

import ServiceModule from './service';
import SceneModule from './scene';

export default angular
    .module('application.scene.identity.scene.forgot-password', [
        ServiceModule.name,
        SceneModule.name
    ])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password', {
        url: '/forgot-password',
        abstract: true,
        template: '<ui-view class="block-component"></ui-view>'
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/index.js